/** @jsxImportSource ./simboluri-jsx */
import { DecizieProiect } from "./tipuri";
import { useT } from "../i18n";
import type { Cheie } from "../i18n";

// DECIZIILE PASULUI — parametrii pe care pasul i-a ALES sau i-a PRESUPUS.
//
// Au avut, o zi, o pagină proprie („Registrul de asumpții"). Stefan a
// nu există: «daca am extras anumiti parametrii sau am
// selectat anumiti parametrii ei trebuie sa faca parte din pasul respectiv. de
// exemplu daca s-a selectat DCH trebuie explicat in acel pas algoritmul. sau
// daca s-a ales o latime a talpii ea face parte din Pasul 6.» O pagină
// separată mai adaugă un loc de monitorizat, iar o decizie ruptă de pasul care
// a luat-o nu se poate citi împreună cu cifrele pe care le schimbă.
//
// Deci fiecare pas își arată propriile decizii, aici, cu patru lucruri pe rând:
// ce s-a decis, cu ce valoare, ce schimbă în calcul și — obligatoriu — cum se
// schimbă. Fără ultima coloană, cititorul vede decizia dar nu are ce face cu
// ea. Nu sunt verificări: nu pică și nu trec.
export default function DeciziiPas({
  decizii,
  titlu = "struct.decizii.titlu",
}: {
  decizii?: DecizieProiect[] | null;
  titlu?: Cheie;
}) {
  const t = useT();
  const lista = (decizii ?? []).filter(Boolean);
  if (!lista.length) return null;
  return (
    <div className="st-findings">
      <h3>
        {t(titlu)} ({lista.length})
      </h3>
      <div className="sg-muted" style={{ marginBottom: 6 }}>{t("struct.decizii.intro")}</div>
      <table className="sg-table">
        <thead>
          <tr>
            <th>{t("struct.decizii.col_ce")}</th>
            <th>{t("struct.decizii.col_valoare")}</th>
            <th>{t("struct.decizii.col_sursa")}</th>
            <th>{t("struct.decizii.col_schimba")}</th>
            <th>{t("struct.decizii.col_cum")}</th>
          </tr>
        </thead>
        <tbody>
          {lista.map((d) => (
            <tr key={d.id}>
              <td>{d.enunt}</td>
              <td className="sg-mono">
                {d.valoare == null ? "—" : String(d.valoare)}
              </td>
              <td className="sg-muted">{d.sursa ?? "—"}</td>
              <td className="sg-muted">{d.implicatie ?? "—"}</td>
              <td className="sg-muted">{d.cum_se_schimba ?? "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
